import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Select, Layer, Logo } from 'components'
import styles from '../index.module.css'
import Lib from 'library';
import { financeSavingDetailState_1 } from './states'
import { useRecoilState } from 'recoil'

const FinanceSavingDetailLayer_1 = () => {

	const [layerControl, setLayerControl] = useRecoilState(financeSavingDetailState_1)

	// const seq = layerControl.seq;
	// const dclsMonth = layerControl.dclsMonth;
	// const finCoNo = layerControl.finCoNo;
	// const finPrdtCd = layerControl.finPrdtCd;
	// const dpst = layerControl.dpst;
	
	const fdiId = layerControl.fdiId; // 상세 id
	const maxRate2 = layerControl.maxRate2; // 우대금리
	const [dpst, setDpst] = useState(null);

	const [dpstOpLst, setDpstOpLst] = useState(null);

	const [monthDt, setMonthDt] = useState("");

	const [isoType, setIsoType] = useState(null);
	const [intType, setIntType] = useState(null);

	const [isoRate, setIsoRate] = useState("");
	const [maxIsoRate, setMaxIsoRate] = useState("");
	const [intRate, setIntRate] = useState("");
	const [maxIntRate, setMaxIntRate] = useState("");

	const [accordionOpen, setAccordionOpen] = useState(true);
	const openAccordion = () => setAccordionOpen(!accordionOpen);

	const depositRate = (data) => {
		console.log('depositRate : ' , data);

		// 단리
		const islt = data.filter(islt =>
			islt.intrRateTypeNm === "단리" && islt.intrRate !== ''
		).map(islt => ({
			save_trm: islt.saveTrm,
			iso_nm: islt.intrRateTypeNm,
			iso_rate: parseFloat(islt.intrRate).toFixed(2),
			iso_rate2: parseFloat(islt.intrRate2).toFixed(2)
		}));

		// 복리
		const intrt = data.filter(intrt =>
			intrt.intrRateTypeNm === "복리" && intrt.intrRate !== ''
		).map(intrt => ({
			save_trm: intrt.saveTrm,
			int_nm: intrt.intrRateTypeNm,
			int_rate: parseFloat(intrt.intrRate).toFixed(2),
			int_rate2: parseFloat(intrt.intrRate2).toFixed(2)
		}));

		// 옵션 값
		const depositOptions = new Map(data.map(deposit => [deposit.saveTrm]));
		const dpstOpDate = [...depositOptions].map((dpst, i) => Number(dpst[0])).sort((a, b) => a - b);
		
		const _islt = dpstOpDate.map((dpst, index) => {
			const _isltOption = islt.find(v => v.save_trm === String(dpst));
			return !_isltOption ? {} : _isltOption;
		})

		const _intrt = dpstOpDate.map((dpst, index) => {
			const _intrtOption = intrt.find(v => v.save_trm === String(dpst));
			return !_intrtOption ? {} : _intrtOption;
		})

		const _list = dpstOpDate.map((v, i) => Object.assign(_islt[i], _intrt[i]))
		
		// 전체 단리/복리 데이터를 saveTrm 개월수 기준, 올림차순으로 데이터 가공 한 값
		setDpstOpLst(_list);
		
		
		// 우대금리 확인
		const maxRate = parseFloat(maxRate2).toFixed(2)
		// 단리기준 우대금리 확인
		let _maxList = _list.filter(max => max.iso_rate2 === maxRate) // 단리
		if(_maxList.length < 1){
			// 단리기준 우대금리 없는 경우 복리로 재확인
			_maxList = _list.filter(max => max.int_rate2 === maxRate) // 복리
		}
		// 초기 값 셋팅
		// 개월수
		setMonthDt(_maxList[0].save_trm || "");

		// 단리 적용
		setIsoType(_maxList[0].iso_nm || null);
		setIsoRate(_maxList[0].iso_rate || "");
		setMaxIsoRate(_maxList[0].iso_rate2 || "")
		
		// 복리적용
		setIntType(_maxList[0].int_nm || null);
		setIntRate(_maxList[0].int_rate || "");
		setMaxIntRate(_maxList[0].int_rate2 || "");
	}

	// 예금 getDepositLst
	const getDepositDetailOption = (fdiId) => {
		Lib.myGet(`/api/recomm/deposit/v1/${fdiId}`, (data) => {
			console.log('예금상세 : ' , data.data);
			setDpst(data.data)
			layerControl.show && depositRate(data.data.options);
		});
	}
	useEffect(() => {
		layerControl.show && getDepositDetailOption(fdiId);
	}, [layerControl.show, fdiId])


	// 원본
	// const getDepositDetailOption = (month, codeNo, prdtCode) => {
	// 	Lib.post(`/api/finance/depositOption?dclsMonth=${month}&finCoNo=${codeNo}&finPrdtCd=${prdtCode}`, (data) => {
	// 		console.log('예금상세 : ' , data);
	// 		layerControl.show && depositRate(data);
	// 	});
	// }

	// // 상세보기시 기간, 금리가 안 보이는 오류가 있어서 매번 조회하도록 수정(layerControl.show 속성추가. 20221020)
	// useEffect(() => {
	// 	layerControl.show && getDepositDetailOption(dclsMonth, finCoNo, finPrdtCd);
	// }, [layerControl.show, dclsMonth, finCoNo, finPrdtCd])



	if (!dpst) return null;

	return (
		<Layer show={layerControl.show} closeLayer={() => setLayerControl(prev => ({ ...prev, show: false }))}>
			<div className="page">
				<div className="shadow">
					<div className="padding">
						<div className="flex-justify_between align_center mt_10">
							<div className={styles["detail-title"]}>
								<span>{dpst.korCoNm}</span>
								<p className="mt_5">{dpst.finPrdtNm}</p>
								<i className="tag tag-box tag-blue mt_10">예금</i>
							</div>
							
								{
									dpst.fin_co_no &&
									<div className="img-box img-symbol img-symbol-lg ml_10">
										<Logo code={dpst.fin_co_no} style={{ 'width': '6rem', 'height': '6rem' }} />
									</div>
								} 
							
						</div>
						<ul className={`${styles["count-list"]} mt_20`}>
							{maxRate2 &&
								<li>
									<p>우대금리</p>
									<strong>{Number(maxRate2).toFixed(2)}%</strong>
								</li>
							}
							{
								dpst.max_limit &&
								<li>
									<p>최고한도</p>
									<strong>{Lib.addComma(dpst.max_limit)}원</strong>
								</li>
							}
						</ul>
					</div>
				</div>
				<div className="shadow">
					<div className="padding">
						<div className={`${accordionOpen ? "active" : ""} accordion-title flex-justify_between align_center`} onClick={openAccordion}>
							<h3>내가 이 상품에 가입한다면?</h3>
							<i className="icon icon_accordion_arrow" />
						</div>
						<div className="accordion-content">
							<div className="flex-justify_center mt_40">
								<i className="icon icon_finance_saving" />
							</div>
							<div className={`${styles["question-area"]} mt_20`}>
								{/* <div className={styles.sec}>{Lib.addEulLeul(dpst.fin_prdt_nm)}</div> */}
								<div className={styles.sec}>
									<Select
										className="mr_10"
										title="저축기간"
										selected={monthDt}
										data={dpstOpLst && dpstOpLst.map((dtOp) => (
											{ key: `${dtOp.save_trm}개월`, value: `${dtOp.save_trm}` }
										))}
										onSelect={(key, value) => {
											setMonthDt(value);

											const dpst = dpstOpLst.find(v => v.save_trm === value);

											setIsoType(dpst.iso_nm || null)
											setIntType(dpst.int_nm || null);

											// 단리
											setIsoRate(dpst.iso_rate || "")
											setMaxIsoRate(dpst.iso_rate2 || "");

											// 복리
											setIntRate(dpst.int_rate || "")
											setMaxIntRate(dpst.int_rate2 || "");
										}}>
									</Select>
									동안 저축할 경우
								</div>
							</div>
							{dpstOpLst &&
								<div className={`${styles["answer-box"]} mt_20`}>
									{/* 단리/복리 모두 표시 */}
									{isoType && <p><strong>단리</strong>로 <strong>{parseFloat(isoRate).toFixed(2)}%</strong> 저축금리를 받을 수 있어요.<br />우대금리는 <strong>최고 {parseFloat(maxIsoRate).toFixed(2)}%</strong> 받을 수 있네요!</p>}
									{intType && <p><strong>복리</strong>로 <strong>{parseFloat(intRate).toFixed(2)}%</strong> 저축금리를 받을 수 있어요.<br />우대금리는 <strong>최고 {parseFloat(maxIntRate).toFixed(2)}%</strong> 받을 수 있네요!</p>}
								</div>
							}
						</div>
					</div>
				</div>
				<div className="padding">
					<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
					    {
                            ( dpst.joinMember != null && dpst.joinMember != "-" ) &&
                            <li>
                                <span>가입대상</span>
                                <span>{dpst.joinMember}</span>
                            </li>
						}
						{
                            ( dpst.joinDeny != null && dpst.joinDeny != "-" ) &&
                            <li>
                                <span>가입제한</span>
                                <span>
                                    {dpst.joinDeny}
                                </span>
                            </li>
						}
						{
                            ( dpst.joinWay != null && dpst.joinWay != "-" ) &&
                            <li>
                                <span>가입방법</span>
                                <span>{dpst.joinWay}</span>
                            </li>
						}
						{
                            ( dpst.mtrtInt != null && dpst.mtrtInt != "-" ) &&
                            <li>
                                <span>만기 후 이자율</span>
                                <span>만기 후<br />
                                    <div style={{ whiteSpace: "pre-wrap" }}>
                                        {dpst.mtrtInt}
                                    </div>
                                </span>
                            </li>
						}
						{
                            ( dpst.spclCnd != null && dpst.spclCnd != "-" ) &&
                            <li>
                                <span>우대조건</span>
                                <span style={{ whiteSpace: "pre-wrap" }}>{dpst.spclCnd}</span>
                            </li>
						}
						{
                            ( dpst.etcNote != null && dpst.etcNote != "-" ) &&
                            <li>
                                <span>기타 유의사항</span>
                                <span style={{ whiteSpace: "pre-wrap" }}>{dpst.etcNote}</span>
                            </li>
						}
						{
                            ( dpst.dclsStrtDay != null || dpst.dclsEndDay != null ) &&
                            <li>
                                <span>공시 기간</span>
                                <span>{dpst.dclsStrtDay} ~ {dpst.dclsEndDay}</span>
                            </li>
						}
					</ul>
					<div className={`${styles["list-guide"]} mt_50`}>금융감독원의 금융상품 API를 통해 제공하는 정보입니다.</div>
				</div>
			</div>
		</Layer>
	)
}

export default FinanceSavingDetailLayer_1